<div id="attribute">
    <div class="index-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
        <div fxLayout="row" fxLayoutAlign="center center">
            <h5>Assigned Users</h5>
        </div>
        <button [attr.guide]="'whats-app-assigne-user-btn-1' + '__' + sanitizedUrl" mat-dialog-close mat-icon-button><mat-icon>
                close
            </mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>
    <form class="padding-10" [formGroup]="firstFormGroup" autocomplete="off">
        <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
            <mat-form-field fxFlex appearance="outline">
                <mat-label>Assigne Users</mat-label>
                <mat-select formControlName="assignedUsersId" [disableOptionCentering]="true" #singleSelect
                    autocomplete="off">
                    <mat-option>
                        <ngx-mat-select-search name="Owner Search" ngDefaultControl [formControl]="typeYFilterControl"
                            placeholderLabel="Owner Search" [preventHomeEndKeyPropagation]="true"
                            noEntriesFoundLabel="No data found">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;" [value]="opt.entityId">
                        {{opt.email}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
            <button [attr.guide]="'whats-app-assigne-user-btn-2' + '__' + sanitizedUrl" type="button" mat-raised-button (click)="close()">Cancel
            </button>
            <button [attr.guide]="'whats-app-assigne-user-btn-3' + '__' + sanitizedUrl" [disabled]="text != 'Save'" (click)="AssignUsers()" mat-raised-button class="blue-button">
                {{text |uppercase}}
                <mat-icon *ngIf="text != 'Save'">
                    <mat-spinner color="primary" diameter="20"></mat-spinner>
                </mat-icon>
            </button>
        </div>
    </form>
</div>